import { useSelector } from "react-redux";
import { ListFilter } from "lucide-react";
import DropdownContainer from "./DropdownContainer";
import LeftIconButton from "../../UI/buttonUI/LeftIconButton";
import FilterReset from "../FilterReset";
import { modifyCategory } from "../../../functions/filter/modifyCategory";

const DesktopFIlterView = ({
  categoryAndOptionList,
  selectedItems,
  setSelectedItems,
  handleFilter,
  originalData,
}) => {
  const isFiltered = useSelector((state) => state.isTableFilter.isFiltered);
  const isMobile = window.innerWidth < 1000;
  if (isMobile) return null; // Do not render anything if mobile

  return (
    <div className="flex items-center">
      {categoryAndOptionList.map((cate, ind) => (
        <DropdownContainer
          key={cate.name}
          name={cate.name}
          selectedItemsLen={selectedItems[modifyCategory(cate.name)]}
          optionsList={cate.optionsList}
          valueAddress={cate.valueAddress}
          setSelectedItems={setSelectedItems}
          unsort={cate.unsort}
        />
      ))}
      <LeftIconButton
        text="Filter"
        btnStyle="text-white bg-dark-blue hover:bg-[#021472e3] mr-1 max-lg:text-xs"
        iconStyle="max-lg:w-4"
        size={18}
        Icon={ListFilter}
        onClick={handleFilter}
      />
      {isFiltered && (
        <FilterReset
          setSelectedItems={setSelectedItems}
          originalData={originalData}
        />
      )}
    </div>
  );
};

export default DesktopFIlterView;
